import {Component, OnInit, ViewChild} from '@angular/core';
import {TdoUserRoleConfigurationModel} from '../../../models/configuration/user/tdo-user-role-configuration.model';
import {UserService} from '../../../services/user.service';
import {DialogService} from '../../../services/dialog.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ConfigurationService} from '../configuration.service';
import {TdoTableV2Component} from '../../../tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import {TdoTableSelectionEvent} from '../../../tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';

@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss']
})
export class RolesComponent implements OnInit {
  @ViewChild('rolesTable') rolesTable: TdoTableV2Component;

  selectedRole: TdoUserRoleConfigurationModel;
  roles: TdoUserRoleConfigurationModel[];
  editedRoles: TdoUserRoleConfigurationModel[] = [];
  isLoading = true;

  constructor(private userService: UserService,
              private snack: MatSnackBar,
              public configurationService: ConfigurationService,
              private dialogService: DialogService) {

  }

  ngOnInit(): void {
    this.userService.getUserRoles().subscribe((res) => {
      this.roles = res;
      //                                                                        this.rolesTable.updateData(this.roles);
      if (this.roles.length > 0) {
        this.selectedRole = this.roles[0];
        setTimeout(() => {
          this.rolesTable.selectionControl.select(this.selectedRole);
        }, 100);
      }
      this.isLoading = false;
    });
  }

  deleteRole(model: TdoUserRoleConfigurationModel) {
    this.dialogService.openConfirmDialog(`Are you sure you want to delete ${model.RoleName}?`).subscribe((result) => {
      if (result === true) {
        this.userService.deleteRole(model.RoleId).subscribe((res) => {
          const idx = this.roles.findIndex(p => p.RoleId === model.RoleId);
          if (idx > -1) {
            this.roles.splice(idx, 1);
            if (this.roles.length > 0) {
              this.selectedRole = this.roles[0];
            }
            this.rolesTable.updateData(this.roles);
          }
        });
      } else {
        //
      }
    });
  }

  onNew(event: any) {
    this.configurationService.setDirty();
    const model = new TdoUserRoleConfigurationModel();
    model.RoleName = 'New Role';
    this.roles.unshift(model);

    this.rolesTable.updateData(this.roles);
  }

  onSave(event: any) {
    this.userService.saveRoles(this.editedRoles).subscribe((res) => {
      this.snack.open('Save success');
      this.configurationService.setClean();
    });
  }

  onInputFinished(event: any) {
    if (!this.editedRoles.includes(this.selectedRole)) {
      this.editedRoles.push(this.selectedRole);
    }
  }

  onRowSelected(event: TdoTableSelectionEvent) {
    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {
        if (res) {
          this.selectedRole = event.model;
          return;
        } else {
          this.rolesTable.selectionControl.select(this.selectedRole);
        }
      });
    } else {
      this.selectedRole = event.model;
    }
  }
}
